export default function putPlanReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'PUT_PLAN_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'PUT_PLAN_ERROR':
            return {...state, ...{error: action.error}};

        case 'PUT_PLAN_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}